import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
  withCredentials: true, // sends HttpOnly refresh-token cookie automatically
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sc_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;
let failedQueue = [];

const drainQueue = (err) => {
  failedQueue.forEach(({ resolve, reject }) => (err ? reject(err) : resolve()));
  failedQueue = [];
};

// These endpoints return 401 legitimately — never attempt a token refresh for them.
const NO_RETRY_URLS = ["/auth/login", "/auth/refresh"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const orig = error.config;
    const skipRetry = NO_RETRY_URLS.some((u) => orig.url?.endsWith(u));
    if (error.response?.status === 401 && !orig._retry && !skipRetry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => failedQueue.push({ resolve, reject }))
          .then(() => api(orig))
          .catch((e) => Promise.reject(e));
      }
      orig._retry = true;
      isRefreshing = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("sc_access_token", data.access_token);
        drainQueue(null);
        return api(orig);
      } catch (e) {
        drainQueue(e);
        localStorage.removeItem("sc_access_token");
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
